module.exports = __webpack_public_path__ + "img/arvhive.48be3ae2.svg";